export function hideBootstrapLoader(document: Document): void {
  const loader = document.getElementById('gapps-bootstrap-loader-id');
  const styles = document.getElementById('gapps-bootstrap-loader-styles-id');

  if (!loader) return;

  const remove = (event: TransitionEvent) => {
    if (event.propertyName !== 'opacity') return;

    loader.remove();
    styles?.remove();
  };

  loader.addEventListener('transitionend', remove);
  loader.classList.add('is-hidden');
}
